'use client';

import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { TESTIMONIALS } from '@/lib/constants';

export function TestimonialsCarousel() {
  const [index, setIndex] = useState(0);
  const total = TESTIMONIALS.length;

  useEffect(() => {
    const id = setInterval(() => setIndex((i) => (i + 1) % total), 6500);
    return () => clearInterval(id);
  }, [total]);

  const t = TESTIMONIALS[index]!;

  return (
    <section className="container-page py-20 sm:py-24">
      <div className="mx-auto max-w-4xl">
        <div className="mb-8 flex items-end justify-between">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-gold-300">
              Testimonios reales
            </p>
            <h2 className="heading-display mt-2 text-3xl text-cream sm:text-4xl">
              Clientes que <span className="text-gold-gradient">confían</span>{' '}
              en Oro Express
            </h2>
          </div>
          <div className="hidden items-center gap-2 sm:flex">
            <button
              type="button"
              aria-label="Anterior"
              onClick={() => setIndex((i) => (i - 1 + total) % total)}
              className="rounded-full border border-white/10 p-2 transition-colors hover:bg-white/5"
            >
              <ChevronLeft className="h-5 w-5 text-cream/70" />
            </button>
            <button
              type="button"
              aria-label="Siguiente"
              onClick={() => setIndex((i) => (i + 1) % total)}
              className="rounded-full border border-white/10 p-2 transition-colors hover:bg-white/5"
            >
              <ChevronRight className="h-5 w-5 text-cream/70" />
            </button>
          </div>
        </div>

        <div className="relative h-[280px] sm:h-[220px]">
          <AnimatePresence mode="wait">
            <motion.figure
              key={index}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -16 }}
              transition={{ duration: 0.45 }}
              className="absolute inset-0 flex flex-col gap-6 rounded-2xl border border-white/10 bg-navy-900/60 p-6 backdrop-blur-md sm:p-8"
            >
              <div className="flex items-center gap-1 text-gold-400">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-gold-400" />
                ))}
              </div>
              <blockquote className="font-editorial text-xl italic leading-relaxed text-cream/90 sm:text-2xl">
                «{t.quote}»
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 text-sm">
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-gold-500/30 to-navy-700 font-display text-base font-bold text-gold-300">
                  {t.initial}
                </div>
                <div>
                  <div className="font-medium text-cream">{t.name}</div>
                  <div className="text-cream/55">{t.role}</div>
                </div>
                <span className="ml-auto rounded-full border border-white/10 bg-white/5 px-2 py-0.5 text-[10px] uppercase tracking-wider text-cream/50">
                  Cliente
                </span>
              </figcaption>
            </motion.figure>
          </AnimatePresence>
        </div>

        <div className="mt-6 flex justify-center gap-2">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              type="button"
              aria-label={`Testimonio ${i + 1}`}
              onClick={() => setIndex(i)}
              className={`h-1.5 rounded-full transition-all ${
                i === index ? 'w-8 bg-gold-500' : 'w-2 bg-white/15'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
